import React, { ReactNode } from 'react';
import '../../styles/MyIconButton.css';

interface MyIconButtonProps {
  onClick: () => void;
  ariaLabel: string;
  children: ReactNode;
  className?: string;
}

const MyIconButton: React.FC<MyIconButtonProps> = ({ 
  onClick, 
  ariaLabel, 
  children, 
  className = ''
}) => {
  return (
    <button 
      className={`my-icon-button ${className}`} 
      onClick={onClick} 
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

export default MyIconButton;
